export const intradayTransactionReportCols = function (withStatementData) {
    const defaultCols =  [ {
        field: "bankName",
        title_key: 'BANK_NAME'
    },{
        field: "bankPlace",
        title_key: 'BANK_PLACE'
    },{
        field: "bic",
        title_key: 'BIC'
    },{
        field: "accountNumber",
        title_key: 'ACCOUNT_NUMBER'
    },{
        field: "currencyCode",
        title_key: 'CURRENCY_CODE'
    },{
        field: "shortName",
        title_key: 'SHORT_NAME'
    },{
        field: "userDefinedAlias1",
        title_key: 'EXPORT_NAME'
    },{
        field: "userNumber",
        title_key: 'USER_NUMBER'
    }];

    const defaultColsEnd = [{
        field: "bookingDate",
        title_key: 'BOOK_DATE'
    }, {
        field: "valueDate",
        title_key: 'VALUE_DATE'
    }, {
        field: "amount",
        title_key: 'AMOUNT'
    }, {
        field: "transactionType",
        title_key: 'TRANSACTION_TYPE'
    }, {
        field: "accountOwnerRef",
        title_key: 'ACC_OWN_REF'
    }, {
        field: "bankReference",
        title_key: 'BANK_REF'
    }, {
        field: "supplementaryText",
        title_key: 'SUPPLEMENT_TEXT'
    }, {
        field: "bookingText",
        title_key: 'BOOK_TEXT'
    }];

    const withStDataCols = [{
        field: "dateTimeIndication",
        title_key: 'DATETIME_IND'
    }, {
        field: "transactionRefNum",
        title_key: 'TRANSACTIONREF_NO'
    }, {
        field: "statementNumber",
        title_key: 'STATEMENT_NUMBER'
    }, {
        field: "creditSum",
        title_key: 'CREDIT_SUM'
    }, {
        field: "debitSum",
        title_key: 'DEBIT_SUM'
    }, {
        field: "infoToAccOwner",
        title_key: 'INF_TO_ACCOWN'
    }];

    const cols = withStatementData ? defaultCols.concat(withStDataCols) : defaultCols;
    return cols.concat(defaultColsEnd);
}
